<style lang="scss" scoped>
@include component(login-error) {
	width: 700px;
	background: white;
	border-radius: 8px;
	margin: auto;
	margin-top: 200px;
	padding: 40px;
	@include part(icon) {
		font-size: 70px;
		margin-right: 20px;
		color: #ff5b5b;
		@include option(good) {
			color: green;
		}
	}
	@include part(title) {
		margin-bottom: 5px;
	}
}
</style>

<template>
  <div v-if="loginError" class="login-error d-flex align-items-center">
    <i class="fe fe-alert-circle login-error__icon"></i>
    <div>
      <h1 class="login-error__title">Uh oh! Unauthorised</h1>
      <p class="mb-0">
        You are not authorized to access this app, please
        <a
          href="http://edu.wonde.com"
        >return to wonde.</a>
      </p>
    </div>
  </div>
</template>

<script>
import { onLogin } from "../../vue-apollo";
export default {
	data() {
		return {
			loginError: false
		};
	},
	mounted() {
		this.$apollo
			.mutate({
				mutation: gql`
					mutation JWTLoginMutation($code: String!) {
						JWTLoginMutation(code: $code)
					}
				`,
				variables: {
					code: this.$route.query.code
				},
				update: (store, data) => {
					onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, data.data.JWTLoginMutation);
					this.$router.push({ name: "directory" });
				}
			})
			.catch(e => {
				console.log(e);
				this.loginError = true;
			});
	}
};
</script>
